import React from 'react';
export function Sistema() {
  const stats = ['+110 páginas', '18 plantillas clínicas', '6 Tomos principales', '3 Bonos gratuitos', 'Léxico 100% argentino', 'PDF editable e imprimible'];
  const skills = ['Recepción', 'Historia clínica', 'Plan de tratamiento', 'Consentimientos', 'Protocolos clínicos', 'Emergencias', 'Alta y seguimiento', 'WhatsApp automático', 'Gestión del equipo', 'Economía del consultorio', 'Respaldo legal', 'Fidelización'];
  return <section className="bg-offWhite px-5 py-10 md:py-[70px] text-center" data-id="element-223">
      <div className="mx-auto max-w-[800px]" data-id="element-224">
        <p className="mb-3 font-montserrat text-[11px] font-extrabold uppercase tracking-[3px] text-brandRed" data-id="element-225">
          Sistema N°1 en Argentina
        </p>
        <h2 className="mb-2 font-bebas text-[clamp(30px,5vw,52px)] text-navy" data-id="element-226">
          Todo lo que tu consultorio necesita — en un solo lugar
        </h2>

        <div className="mx-auto mb-6 md:mb-[44px] mt-6 flex max-w-[800px] flex-wrap justify-center gap-3" data-id="element-227">
          {stats.map((stat, i) => <span key={i} className="rounded-full bg-navy px-[18px] py-2 font-montserrat text-[12px] font-bold tracking-[0.5px] text-white" data-id="element-228">
              {stat}
            </span>)}
        </div>

        <div className="mx-auto mb-6 md:mb-[44px] flex max-w-[800px] flex-wrap justify-center gap-2.5" data-id="element-229">
          {skills.map((skill, i) => <span key={i} className="rounded-full border-[1.5px] border-brandGray-light bg-white px-4 py-[7px] font-montserrat text-[12px] font-semibold text-navy-mid" data-id="element-230">
              {skill}
            </span>)}
        </div>

        <p className="text-[15px] text-brandGray" data-id="element-231">
          Funciona desde hoy en tu consultorio — imprimible o digital.
        </p>
      </div>
    </section>;
}